import './Layer.css';

function Layer(){
    return(
        <div className='page-layer'>
            <img src="/assets/imagenes/SEO/logo-principal.jpg" alt="Logo principal de Homesleep"/>
            <div className="layer-loader"></div>
        </div>
    )
}

export default Layer;
